import ReAvatar from '@/elements/ReAvatar.vue'
import ReBadge from '@/elements/ReBadge.vue'
import ReBanner from '@/elements/ReBanner.vue'
import ReButton from '@/elements/ReButton.vue'
import ReCheckbox from '@/elements/ReCheckbox.vue'
import ReDateTimePicker from '@/elements/ReDateTimePicker.vue'
import ReDialog from '@/elements/ReDialog.vue'
import ReDrawer from '@/elements/ReDrawer.vue'
import ReField from '@/elements/ReField.vue'
import ReForm from '@/elements/ReForm.vue'
import ReIcon from '@/elements/ReIcon.vue'
import ReInput from '@/elements/ReInput.vue'
import ReLoading from '@/elements/ReLoading.vue'
import ReMarkdownEditor from '@/elements/ReMarkdownEditor.vue'
import ReMarkdownRenderer from '@/elements/ReMarkdownRenderer.vue'
import ReMultiChoice from '@/elements/ReMultiChoice.vue'
import RePage from '@/elements/RePage.vue'
import ReSelect from '@/elements/ReSelect.vue'
import ReSlider from '@/elements/ReSlider.vue'
import ReStatic from '@/elements/ReStatic.vue'
import ReStepperInput from '@/elements/ReStepperInput.vue'
import ReTitle from '@/elements/ReTitle.vue'
import ReTooltip from '@/elements/ReTooltip.vue'

const ReLibrary = {
  install(app) {
    app.component('ReButton', ReButton)
    app.component('ReCheckbox', ReCheckbox)
    app.component('ReField', ReField)
    app.component('ReInput', ReInput)
    app.component('ReStepperInput', ReStepperInput)
    app.component('ReSelect', ReSelect)
    app.component('ReTooltip', ReTooltip)
    app.component('ReIcon', ReIcon)
    app.component('ReAvatar', ReAvatar)
    app.component('ReTitle', ReTitle)
    app.component('ReMultiChoice', ReMultiChoice)
    app.component('ReDateTimePicker', ReDateTimePicker)
    app.component('RePage', RePage)
    app.component('ReDialog', ReDialog)
    app.component('ReBanner', ReBanner)
    app.component('ReLoading', ReLoading)
    app.component('ReForm', ReForm)
    app.component('ReSlider', ReSlider)
    app.component('ReStatic', ReStatic)
    app.component('ReBadge', ReBadge)
    app.component('ReDrawer', ReDrawer)
    app.component('ReMarkdownRenderer', ReMarkdownRenderer)
    app.component('ReMarkdownEditor', ReMarkdownEditor)
  },
}

export default ReLibrary
